<template>
  <el-dialog class="demand_model_dialog" top="5vh" center :title="newTitle" width="80%" :before-close="handleClose"
             :visible.sync="dialogVisible" :close-on-click-modal="false">
    <el-form v-loading="loading.dialog" size="mini" ref="form" :rules="rules" :model="form">
      <div style="display: flex;margin-bottom: 16px;">
        <el-form-item label="提交人" :label-width="formLabelWidth">
          <span>{{username_cn}}</span>
          <el-button v-if="isTakeUser" size="mini" type="text" style="margin-left: 5px;" @click="dialogVisibleTakeUser = true">代客下单</el-button>
<!--          <el-input :value="username_cn" autocomplete="off" disabled="true">-->
<!--          </el-input>-->
        </el-form-item>
        <el-form-item label="所属部门" :label-width="formLabelWidth" style="width: 48%;">
          <span>{{department}}</span>
<!--          <el-input :value="department" autocomplete="off" disabled="true" >
          </el-input>-->
        </el-form-item>
        <el-form-item label="提交日期" :label-width="formLabelWidth">
          <span>{{create_date}}</span>
<!--          <el-input :value="create_date" autocomplete="off" disabled="true">-->
<!--          </el-input>-->
        </el-form-item>
      </div>
      <div style="display: flex;margin-bottom: 16px;" v-if="form.state_code > 0 && (form.project_system || form.level_name || form.classify_name)">
        <el-form-item label="受理人" prop="ownerId" :label-width="formLabelWidth" style="width:25%;">
          <span>{{form.accepted_user_nameZh}}</span>
<!--          <el-select size="mini" disabled="true"  v-model="form.accepted_user_id" filterable-->
<!--                     placeholder="请选择">-->
<!--            <el-option v-for="(key, value) in allUserList.ALLUSERTYPE1" :key="key" :label="key" :value="value">-->
<!--            </el-option>-->
<!--          </el-select>-->
        </el-form-item>
        <el-form-item label="级别" prop="name" :label-width="formLabelWidth" style="width:25%;" v-if="form.level_name">
          <span :style="{ color: form.level_name == '紧急' ? 'red' : '' }"> {{form.level_name}}</span>
<!--          <el-select size="mini"   v-model="form.level" filterable placeholder="请选择" :disabled="true">-->
<!--            <el-option v-for="(key, value) in workOrderConfig.LEVEL" :key="key" :label="key" :value="value">-->
<!--            </el-option>-->
<!--          </el-select>-->
        </el-form-item>
        <el-form-item label="分类" prop="name" :label-width="formLabelWidth" style="width:25%;" v-if="form.classify_name">
          <span>{{form.classify_name}}</span>
<!--          <el-select size="mini" v-model="form.classify" filterable placeholder="请选择" :disabled="true">
            <el-option v-for="(key, value) in workOrderConfig.CATEGORY" :key="key" :label="key" :value="value">
            </el-option>
          </el-select>-->
        </el-form-item>
        <el-form-item label="项目体系" prop="name" :label-width="formLabelWidth" style="width:25%;" v-if="form.project_system">
          <span>{{form.project_system}}</span>
          <!--          <el-select size="mini" v-model="form.classify" filterable placeholder="请选择" :disabled="true">
                      <el-option v-for="(key, value) in workOrderConfig.CATEGORY" :key="key" :label="key" :value="value">
                      </el-option>
                    </el-select>-->
        </el-form-item>
      </div>
      <div style="display: flex;">
        <el-form-item label="类型" prop="type" :label-width="formLabelWidth">
          <el-radio-group v-model="form.type">
          <el-radio :disabled="isProjectDisabled"  v-for="(key, value) in workOrderConfig.WORDERORDERTYPE" :label="value" :key="key">{{key}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="系统" prop="module_code" :label-width="formLabelWidth">
          <el-select  size="mini"  v-model="form.module_code" :disabled="isProjectDisabled" collapse-tags filterable placeholder="请选择系统">
            <el-option v-for="(key, value) in workOrderSystem" :key="key" :label="key" :value="value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" :label-width="formLabelWidth">
          <span>{{form.state}}</span>
<!--          <el-input :value="form.state" autocomplete="off" disabled="true">-->
<!--          </el-input>-->
        </el-form-item>
        <el-form-item label="受理人" prop="ownerId" :label-width="formLabelWidth" style="width:25%;"  v-if="form.state_code > 0 && !form.project_system && !form.level_name && !form.classify_name">
          <span>{{form.accepted_user_nameZh}}</span>
        </el-form-item>
        <el-form-item label="项目体系" :label-width="formLabelWidth" style="width:25%;"  v-if="form.state_code == 0 && this.form.project_system">
          <span>{{form.project_system}}</span>
        </el-form-item>
      </div>
      <div style="display: flex">
      <el-form-item label="处理人" prop="acceptor_id" :label-width="formLabelWidth" v-if="form.type == 1 && !isUpdata">
        <el-select size="mini"  v-model="form.acceptor_id" :disabled="isProjectDisabled" filterable placeholder="请选择">
          <el-option v-for="(key, value) in allUserList.ALLUSERTYPE1" :key="key" :label="key" :value="value">
                    </el-option>
        </el-select>
      </el-form-item>
        <el-form-item label="项目体系" prop="acceptor_id" :label-width="formLabelWidth" v-if="form.type == 1 && !isUpdata">
          <el-select size="mini" v-model="form.project_system_id" collapse-tags filterable
                     placeholder="请选择项目体系" clearable>
            <el-option v-for="(key, value) in allSystem.ALLSYSTEMIDS" :key="key" :label="key" :value="value">
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <el-form-item label="标题" prop="title" :label-width="formLabelWidth">
        <el-input v-model="form.title" autocomplete="off" :disabled="isProjectDisabled" placeholder="建议格式为：问题单据号-SKU-问题简要描述">
        </el-input>
      </el-form-item>
      <el-form-item label="描述" prop="desc" :label-width="formLabelWidth">
        <Editor v-if="!loading.dialog" :content="form.desc" @contentData="changeContent"
                :dialogVisibleModelType="form.id ? 'update' : 'create'" :edithHeight="form.id ? edithHeight:''"/>
      </el-form-item>
      <el-form-item label="上传附件" prop="evaluation" :label-width="formLabelWidth">
        <el-upload class="upload-demo" action="https://devops-test.ehsy.com/devops/common/upload"
                   :on-preview="handlePreview" :before-remove="beforeRemove" multiple :limit="5" :on-success="handleSuccess"
                   :on-remove="handleRemove" :before-upload="beforeUpload" :file-list="fileList" :disabled="isProjectDisabled">
          <el-button size="mini" type="primary" :disabled="isProjectDisabled">点击上传</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="需求" :label-width="formLabelWidth" v-if="form.state_code > 0">
        <el-button size="mini" @click="onAddDemand()"  type="primary" :disabled="isCreateDemandPm">
          创建需求</el-button>
      </el-form-item>
      <el-form-item label="" :label-width="formLabelWidth" v-if="orderDeamndList.length > 0">
        <el-table :data="orderDeamndList" border style="width: 100%; margin-top: -10px;"  height="40vh" stripe :cell-style="getRowClass" :header-cell-style="getCellClass">
          <el-table-column sortable fixed prop="id" align="center" label="需求ID" width="90">
          </el-table-column>
          <el-table-column prop="demandName" align="center" label="需求名称" min-width="120" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span class="table_text_click_new"
                    @click="onAddDemand(scope.row)">{{ scope.row.demandName }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="projectSystemName" align="center" label="项目体系" width="100" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="projectName" align="center" label="项目名称" width="100" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="demander" align="center" label="需求人员" width="80" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.demander.nameZh }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="pm" align="center" label="产品经理" width="80" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.pm.nameZh }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="reviewer" align="center" label="技术负责人" width="100" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.reviewer.nameZh }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="statusDesc" align="center" label="需求状态" width="80" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="planFinishDate" align="center" label="计划上线日期" width="120" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="processRate" align="center" label="需求进度" width="80" :show-overflow-tooltip="true">
            <template slot-scope="scope">
            <span class="priority_style">
              {{ scope.row.processRate || scope.row.processRate == 0 ? scope.row.processRate + '%' : '' }}
            </span>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label="任务" :label-width="formLabelWidth" v-if="form.state_code > 0">
        <el-button size="mini" @click="onAddWorkTask()"  type="primary" :disabled="isCreateOtherTask">
          创建任务</el-button>
      </el-form-item>
      <el-form-item label=""   :label-width="formLabelWidth" v-if="orderTaskList.length > 0">
        <el-table  :data="orderTaskList" border style="width: 100%; margin-top: -10px;"  height="40vh" stripe :cell-style="getRowClass" :header-cell-style="getCellClass">
          <el-table-column prop="id" sortable fixed label="任务ID" width="90">
          </el-table-column>
          <el-table-column prop="title" label="任务名称" min-width="180">
            <template slot-scope="scope">
              <span class="table_text_click_new" @click="onAddWorkTask(scope.row)">{{ scope.row.title }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="status_desc" label="任务状态">
          </el-table-column>
          <el-table-column prop="projectSystemName" align="center" label="项目体系" width="100" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="type" label="任务类型">
            <template slot-scope="scope">
              <span> {{NEWOTHERTYPE[scope.row.type]}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="creator_id" label="创建人">
            <template slot-scope="scope">
              <span>
             {{scope.row.creator_id.nameZh}}
            </span>
            </template>
          </el-table-column>
          <el-table-column prop="owner_id" label="负责人">
            <template slot-scope="scope">
              <span>
             {{scope.row.owner_id.nameZh}}
            </span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" align="center" label="创建时间" width="120" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="planFinishDate" align="center" label="计划完成日期" width="120" :show-overflow-tooltip="true">
          </el-table-column>
        </el-table>
      </el-form-item>

      <el-form-item label="处理结果" :label-width="formLabelWidth" v-if="form.dispose_result">
        <Editor  :content="form.dispose_result" :dialogVisibleModelType="form.id ? 'update' : 'create'" />
      </el-form-item>

      <el-form-item label="处理凭证" :label-width="formLabelWidth" v-if="resultList.length > 0">
        <el-upload class="upload-result" :on-preview="handlePreview" :before-remove="beforeRemoveResult" :on-remove="handleRemoveResult" :file-list="resultList">
        </el-upload>
      </el-form-item>

      <el-form-item v-if="isUpdata && followList.length" label="操作历史" :label-width="formLabelWidth">
        <div class="followList">
          <OperationHistory  :followList="followList"></OperationHistory>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button v-show="isUpdata && step === 1 && isCreateUser && form.state_code>= 0 && form.state_code < 4" type="warning" @click="changeStep(2)">编 辑</el-button>
      <el-button v-show="!isUpdata || (isUpdata && step === 2 && isCreateUser)" type="warning" :loading="loading.submit" @click="onSubmit">确 定</el-button>
      <el-button v-if="form.state_code === 0 && step === 1 && !isCreateUser"  type="primary" :loading="loading.submitReviewed" @click="onClaimOrder()">认 领</el-button>
      <el-button v-if="isTransferOrder" type="primary" :loading="loading.submitRollBack" @click="onTransferOrder()">转 交</el-button>
      <el-button  v-if="form.state_code === 0 && isCreateUser && step === 1" type="danger" :loading="loading.cancelWorkOrder" @click="onCancelWorkOrder">取消工单</el-button>
      <el-button v-if="(form.state_code === 1 || form.state_code === 2) && isAcceptedUser && step === 1" type="primary" :loading="loading.submitRollBack" @click="onFinishWorkOrder()">完结工单</el-button>
      <el-button  v-if="form.state_code === 3 && isCreateUser && step === 1" type="primary" :loading="loading.submitRollBack" @click="onFinishValidateWorkOrder()">验 收</el-button>
      <el-button type="success" @click="handleClose">关 闭</el-button>
    </div>
    <Task v-if="dialogVisibleTask" :dialogVisible='dialogVisibleTask' :hideDialogVisible="handleTaskClose" :formInfo="formTaskInfo" />
    <TestTask v-if="dialogVisibleTestTask" :dialogVisible='dialogVisibleTestTask' :hideDialogVisible="handleTestTaskClose" :formInfo="formTestTaskInfo"/>
    <AddMeet v-if="dialogVisibleMeet" :demandId="form.id"  :stage="getStage" :dialogVisible='dialogVisibleMeet' :hideDialogVisible="handleMeetClose"/>
    <el-dialog center :append-to-body="true" :title="newTitle" :visible.sync="dialogVisiblePStatus" width="40%">
      <el-form :model="pStatusForm" :rules="pStatusRules" ref="pStatusForm" >
        <el-form-item label="修改需求状态" prop="status" :label-width="formLabelWidth" >
          <el-select v-model="pStatusForm.status" placeholder="请选择" >
            <el-option label="暂停" value="13"></el-option>
            <el-option label="取消" value="14"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="原因" prop="changeReason" :label-width="formLabelWidth" >
          <el-input type="textarea" rows="3" v-model="pStatusForm.changeReason" autocomplete="off" placeholder="需求状态变更原因" />
        </el-form-item>
        <el-form-item label=""  :label-width="formLabelWidth">
          <el-button size="small" type="primary" @click="onChangePStatus">确 定</el-button>
          <el-button size="small" @click="dialogVisiblePStatus = false">取 消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog center :append-to-body="true" title="代客下单" :visible.sync="dialogVisibleTakeUser" width="40%">
      <el-form :model="pUserForm" :rules="pUserRules" ref="pUserForm" >
        <el-form-item label="提出人" prop="submitter_id" label-width="60px">
          <el-select size="mini"  v-model="pUserForm.submitter_id" filterable clearable placeholder="请选择"  style="width:80%;height: 36px;">
            <el-option v-for="(key, value) in allUserList.ALLUSERTYPE1" :key="key" :label="key" :value="value">
            </el-option>
          </el-select>
        </el-form-item>
        <div style="margin: 0 auto;text-align: center;">
          <el-button size="small" type="primary" @click="onChangeTakeUser">确 定</el-button>
          <el-button size="small" @click="dialogVisibleTakeUser = false">取 消</el-button>
        </div>
      </el-form>
    </el-dialog>
    <!-- 申请发布页面  -->
    <Demand v-if="dialogVisibleCreateDemand" :dialogVisible='dialogVisibleCreateDemand' :hideDialogVisible="handleCreateDemandClose" :workId="form.id" :formInfo="demandInfo" />
    <CreateImport v-if="dialogVisibleImportTask" :dialogVisible='dialogVisibleImportTask' :hideDialogVisible="handleImportTaskClose" :formInfo="form"></CreateImport>
    <TransferOrder v-if="dialogVisibleTransferOrder" :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisibleTransferOrder'
                   :hideDialogVisible="handleTransferOrderClose" :formInfo="TransferInfo"></TransferOrder>
    <ClaimOrder v-if="dialogVisibleClaimOrder" :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisibleClaimOrder'
                :hideDialogVisible="handleClaimOrderClose" :formInfo="TransferInfo"></ClaimOrder>

<!--    <CreateDemand v-if="dialogVisibleCreateDemand" :dialogVisible='dialogVisibleCreateDemand' :hideDialogVisible="handleCreateDemandClose" :workId="form.id" :formInfo="demandInfo"></CreateDemand>
    -->
    <CreateWorkTask  v-if="dialogVisibleCreateWorkTask" :showDialogVisible="showDialogVisibleOtherTask" :dialogVisible='dialogVisibleCreateWorkTask' :hideDialogVisible="handleCreateWorkTaskClose" :workId="form.id" :formInfo="taskInfo"></CreateWorkTask>
    <FinishWorkOrder v-if="dialogVisibleFinishWorkOrder" :dialogVisible='dialogVisibleFinishWorkOrder' :hideDialogVisible="handleFinishWorkOrderClose" :workId="form.id" :formInfo="form"></FinishWorkOrder>
    <ValidateOrder v-if="dialogVisibleValidateWorkOrder"  :dialogVisible='dialogVisibleValidateWorkOrder' :hideDialogVisible="handleFinishValidateWorkOrderClose" :workId="form.id" :formInfo="form"></ValidateOrder>
  </el-dialog>
</template>
<script>
import { Editor } from "@/components/index.js";
import Task from '@/views/tops/devOps/producerSpace/components/task.vue'
import Comment from '@/views/tops/devOps/producerSpace/components/project/comment.vue'
import { formatEnToUtf8 } from "@/views/tops/devOps/components/util.js"
import  MeetList from "@/views/tops/devOps/producerSpace/components/meeting/list.vue";
import AddMeet from "@/views/tops/devOps/producerSpace/components/meeting/addMeet.vue";
import TestTask from '@/views/tops/devOps/producerSpace/components/testTask.vue';
import {TaskHistory} from "@/views/tops/devOps/components/list";
import CreateImport from "@/views/tops/devOps/producerSpace/components/createImport.vue";
import TransferOrder from "@/views/tops/devOps/workOrder/components/transferWorkOrder.vue";
import CreateDemand from "@/views/tops/devOps/workOrder/components/createDemand.vue";
import CreateWorkTask from "@/views/tops/devOps/producerSpace/components/other/create.vue";
import FinishWorkOrder from "@/views/tops/devOps/workOrder/components/finishWorkOrder.vue";
import ValidateOrder from "@/views/tops/devOps/workOrder/components/validateWorkOrder.vue";
import ClaimOrder from "@/views/tops/devOps/workOrder/components/claimWorkOrder.vue";
import OperationHistory from "@/views/tops/devOps/workOrder/components/operationHistory.vue";
import {
  getDevOpsSpaceProducerListApi,
  postDevOpsSpaceDeleteTaskApi,
  postDevOpsSpaceUserPmEditStatusApi,
  postDevOpsSpaceCreateDemandApi,
  getDevOpsSpaceFindOneDemandApi,
  postDevOpsSpaceEditDemandApi,
  getDevOpsSpaceFindProjectNameApi,
  postDevOpsSpaceSubmitDemandApi,
  getDevOpsSpaceMeetListApi,
  getDevOpsSpaceDemandTestTaskApi,
  getDevOpsSpaceHistoryTaskListApi,
  getDevOpsSpaceReportTaskListApi,
  postDevOpsSpaceDeleteTestTaskApi,
  getDevOpsSpaceDemandSkipApi,
  postDevOpsSpaceUpdatePlanDateApi,
  postDevOpsSpaceCreateSystemApi,
  getDevOpsSpaceUserDepartmentInfoApi,
  postDevOpsSpaceCreateWorkOrderApi,
  getDevOpsSpaceWorkOrderDetailApi,
  postDevOpsSpaceUpdateWorkOrderApi,
  getDevOpsSpaceWorkOrderDemandListlApi,
  getDevOpsSpaceWorkOrderTaskListlApi, postDevOpsSpaceClaimWorkOrderApi, getDevOpsSpaceReminderWorkOrderListlApi
} from "@/server/tops/devOps";
import { mapState } from "vuex";
import {getDevOpsSpaceAllUserListApi, getDevOpsSpaceWorkOrderConfigApi} from "@/server/tops/base";
import createImport from "@/views/tops/devOps/producerSpace/components/createImport.vue";
import {Demand} from "@/views/tops/devOps/producerSpace/components";

export default {
  components: {
    Demand,
    TaskHistory, Editor, Comment, Task, MeetList, AddMeet, TestTask, CreateImport, TransferOrder,CreateDemand, CreateWorkTask, FinishWorkOrder, ValidateOrder, ClaimOrder, OperationHistory},
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {}
      },
    },
    tabid: {
      type: String,
      default: '',
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    showDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
  },
  data() {
    return {
      meetList:[],
      historylist: [],
      form: {
        title:'',
        type:'0',
        module_code:'',
        desc:'',
        adjunct:'',
        state:'待处理',
        accepted_user_id:'',
        accepted_user_nameZh:'',
        level_name:'',
        classify_name:'',
        acceptor_id:'',
        project_system_id:'',
      },
      pUserForm:{
        submitter_id:'',
      },
      pUserRules:{
        submitter_id:{
          required: true,
          message: "必填",
          trigger: "blur",
        }
      },
      pStatusForm:{
        isRestart: false,
        isRollBack: false,
        status:'',
        changeReason:'',
        back_status:false,
        id:''
      },
      pUatForm:{
        uatStatus:'',
        uatDetail:'',
      },
      proForm:{
        proStatus:'',
        proDetail:'',
      },
      pSkipForm:{
        skipReason:'',
      },
      updateTimeForm:{
        planFinishDate:'',
        update_date_reason:'',
      },
      addSystemForm:{
        module_value:'',
      },
      reviewerForm:{
        reviewer:'',
        loading:false
      },
      pStatusRules:{
        status:{
          required: true,
          message: "必填",
          trigger: "blur",
        },
        changeReason:{
          required: true,
          message: "必填",
          trigger: "blur",
        }
      },
      pUatRules:{
        uatStatus:{
          required: true,
          message: "必填",
          trigger: "blur",
        },
        uatDetail:{
          required: true,
          message: "必填",
          trigger: "blur",
        }
      },
      proRules:{
        proStatus:{
          required: true,
          message: "必填",
          trigger: "blur",
        },
        proDetail:{
          required: true,
          message: "必填",
          trigger: "blur",
        }
      },
      pSkipRules:{
        skipReason:{
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      addSystemRules:{
        module_value:{
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      rules: {
        title: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        type: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        module_code: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        desc: {
          required: true,
          message: "必填",
          trigger: "blur",
        }
      },
      formLabelWidth: '135px',
      chainingLink: true,
      chainingLinkTo: true,
      loading: {
        dialog: false,
        submit: false,
        submitReviewed: false,
        submitRollBack:false,
        submitConfirmReviewer: false,
        submitDemand: false,
        submitReset: false,
        submitUat: false,
        submitApply: false,
        submitCancel: false,
        submitComplete: false,
        skipRelease: false,
        addSystemLoad: false,
        cancelWorkOrder: false,
      },
      tasks: [],
      testTasks: [],
      dialogVisibleTask: false,
      dialogVisibleTestTask: false,
      dialogVisiblePStatus:false,
      dialogVisiblePUat: false,
      dialogVisibleReviwer: false,
      dialogVisibleMeet: false,
      dialogVisiblePro: false,
      dialogVisibleSkip: false,
      dialogVisibleAddSystem: false,
      step: 1,
      formTaskInfo: {},
      formTestTaskInfo: {},
      reviewerSelect: [],
      showDetails: false,
      // 判断是否是产品
      isUserPm:false,
      projectList: [],
      dialogVisibleApplyRelease: false,
      UATSTATUS:['失败','成功'],
      userId:'',
      username: '',
      record: false,
      updateText:[],
      recordList:[],
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() <= Date.now() - 60 * 60 * 24 * 1000;
        }
      },
      dialogVisibleImportTask: false,
      dialogVisibleTransferOrder: false,
      dialogVisibleCreateDemand: false,
      dialogVisibleCreateWorkTask: false,
      dialogVisibleFinishWorkOrder: false,
      dialogVisibleValidateWorkOrder: false,
      dialogVisibleClaimOrder: false,
      workOrderLevel:[],
      workOrderSystem:[],
      username_cn:'',
      nowDate:this.getDate(),
      create_date:'',
      department:'',
      fileList:[],
      resultList:[],
      TransferInfo:{},
      orderDeamndList:[],
      orderTaskList:[],
      demandInfo:{},
      taskInfo:{},
      followList:[],
      dialogVisibleTakeUser: false,
      edithHeight:'',
    };
  },
  async mounted() {
    const { id = '', status = '',  name = '', next = false } = this.formInfo;
    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
    const username_cn = this.$store.state.devOps.userInfo.user_name_zh? this.$store.state.devOps.userInfo.user_name_zh : '';
    const username_id = this.$store.state.devOps.userInfo.userId? this.$store.state.devOps.userInfo.userId : '';
    this.form = { ...this.form, id,username_id}
    this.$set(this.form, 'username', username)
    this.username = username;
    await this.getWorkOrderConfig();
    if (this.isUpdata) {
      await this.init(id);
      await this.workOrderDemandList();
      await this.workOrderTaskList();
      await this.getReminderWorkOrderListlApi();
    } else {
      if(this.$store.state.devOps.userInfo.userId){
        let defaulepmId = this.$store.state.devOps.userInfo.userId;
      }
      this.username_cn = username_cn + '(' +username+')';
      this.form.submitter_id = username_id;
      this.create_date = this.getDate();
      await this.getWorkOrderUserDepartment();
      this.step = 2;
    }

    if(this.$store.state.devOps.userInfo.userId){
      this.userId = this.$store.state.devOps.userInfo.userId;
    }

    //获取未开始，进行中的项目
    this.$nextTick(async () => {
      //await this.getProjectList();
    })
  },
  computed: {
    createImport() {
      return createImport
    },
    ...mapState(
        {
          allSelect: (state) => state.devOps.ALLSELECT,
          allSystem: (state) => state.devOps.ALLSYSTEM,
          allUserList: (state) => state.devOps.ALLUSERLIST,
          NEWOTHERTYPE: (state) => state.devOps.NEWOTHERTYPE,
          workOrderConfig: (state) => state.devOps.WORKORDERCONFIG,
          allMenuList: (state) => state.devOps.NEWALLMENULIST,
        }
    ),
    newTitle() {
      if (this.isUpdata) {
        return '[' + this.form.id + ']工单-' + this.form.title;
      } else {
        return '创建工单'
      }
    },
    //获取阶段
    getStage(){
      //需求讨论
      if(this.form.status === 0 || this.form.status === 1){
        return '1';
      }
      //需求评审
      if(this.form.status === 2 || this.form.status === 3){
        return '2'
      }
      //技术评审
      if(this.form.status === 4 || this.form.status === 5) {
        return '3';
      }
    },
    // 判断需求状态
    isPStatus() {
      const { status } = this.form;
      if( status === 13 || status === 14) return false;
      return true
    },
    //
    isChangetatus() {
      return this.form.status === 13 || this.form.status === 14 || this.form.status === 9 || this.form.status === 10 || this.form.status === 11 || this.form.status === 12;
    },
    // 判断是否是技术负责人
    isReviewer() {
      if(this.isAdmin || this.isReviewerLeader) return true;
      return this.form.reviewer.nameEn === this.form.username;
    },
    //判断技术负责人可以编写
    isReviewerEdit(){
      if(this.isReviewer){
        return this.form.status === 4 || this.form.status === 5;
      }
      return false;
    },
    // 判断是否是创建人
    isCreateUser(){
      if(this.isAdmin) return true;
      if(this.form.creator_id){
        return this.form.creator_id.id == this.form.username_id;
      }
      return false;
    },
    isAcceptedUser(){
      if(this.isAdmin) return true;
      return this.form.accepted_user_id == this.form.username_id;
    },
    // 判断是否是产品
    isPm(){
      if(this.isAdmin || this.isPmLeader) return true;
      if(this.form.pm){
        return this.form.pm.nameEn === this.form.username;
      }
      return false;
    },
    isAddMeet(){

      return (this.isPm && (this.form.status === 0 || this.form.status === 1 || this.form.status === 2 || this.form.status === 3)) || (this.isReviewer &&(this.form.status === 4 || this.form.status === 5));

    },
    isAdmin(){
      if(this.username){
        if(this.allUserList.ALLUSERTYPE13 && this.allUserList.ALLUSERTYPE13[this.username]) return true
      }
      return false;
    },
    isPmLeader(){
      if(this.userId && this.form.pm){
        const pmId = this.form.pm.id;
        if(this.allUserList.LEADERUSER && this.allUserList.LEADERUSER[pmId]){
          return this.allUserList.LEADERUSER[pmId] === this.userId;
        }
      }
      return false;
    },
    isReviewerLeader(){
      if(this.userId && this.form.reviewer){
        const reviewerId = this.form.reviewer.id;
        if(this.allUserList.LEADERUSER && this.allUserList.LEADERUSER[reviewerId]){
          return this.allUserList.LEADERUSER[reviewerId] === this.userId ;
        }
      }
      return false;
    },
    //提交技术评审
    isSubmitReviewer(){
      return this.form.status === 2 || this.form.status === 3;
    },
    //提交需求评审
    isSubmitDemand(){
      return this.form.status === 1 || this.form.status === 0;
    },
    //回退
    isRollback(){
      return this.form.status === 4;
    },
    //确认评审
    isConfirmReviewer(){
      return this.form.status === 4 || this.form.status === 5;
    },
    //是否可编辑
    isEditDemand(){
      return this.form.status === 0 || this.form.status === 1 || this.form.status === 2 || this.form.status === 3;
    },
    // 判断是否是新建
    isUpdata() {
      return this.form.id;
    },
    // 需求部分不可编辑
    isProjectDisabled() {
      if (this.isUpdata) { // 如果是更新页面
        if (this.step === 1) return true;
      }
      return false; // 默认可编辑
    },
    // 展示技术负责人部分的表单
    showReviewedForm() {
      return this.form.status != 0 && this.form.status != 1 && this.form.status != 2 && this.form.status != 3;
    },
    // 判断是否展示任务添加
    showTaskAdd() {
      const { status, username, reviewer } = this.form;
      if ( status !== 13 && status !== 1 && status > 3 && status < 8) {
        return true;
      }
      return false;
    },
    // 判断是否展示任务列表
    showTaskList() {
      return  this.tasks.length;
    },
    isTakeUser(){
      const roles = this.allUserList['MYROLES']
      if(roles[12]  &&  !this.isUpdata){
        return true;
      }
      return false;
    },
    //判断是否是产品
    isCreateDemandPm() {
      const roles = this.allUserList['MYROLES']
      if(roles[2] && this.form.state_code != 4 && this.form.state_code != 5 &&  this.isAcceptedUser){
        return false;
      }
      return true;
    },
    //判断是否可以创建其他任务
    isCreateOtherTask(){
      if(this.allMenuList.btn_other_task_clear && this.form.state_code != 4 && this.form.state_code != 5){
        return false;
      }
      return true;
    },
    //判断是否可以转交
    isTransferOrder(){
      if(this.form.state_code == 0 && !this.isCreateUser){
        return true;
      }else if(this.form.state_code == 4 ){
        return false;
      }else{
        return (this.form.state_code === 1 || this.form.state_code === 2) && this.isAcceptedUser && this.step === 1
      }
    },
  },
  methods: {
    async getReminderWorkOrderListlApi() {
      await getDevOpsSpaceReminderWorkOrderListlApi({workId: this.formInfo.id, type: '1'}).then((res) => {
        this.followList = res.data;
      })
    },
    async workOrderDemandList() {
      await getDevOpsSpaceWorkOrderDemandListlApi({work_id: this.form.id}).then((res) => {
         if(res.status === 'success'){
           this.orderDeamndList = res.data;
         }
      })
    },
    async workOrderTaskList() {
      await getDevOpsSpaceWorkOrderTaskListlApi({work_id: this.form.id}).then((res) => {
        if(res.status === 'success'){
          this.orderTaskList = res.data;
        }
      })
    },
    async getWorkOrderUserDepartment(userId='') {
      if(!userId){
        userId = this.$store.state.devOps.userInfo.userId;
      }
      await getDevOpsSpaceUserDepartmentInfoApi({user_id : userId}).then((res) => {
        this.department= res.data.dept_name;
      })
    },
    async getWorkOrderConfig() {
      await getDevOpsSpaceWorkOrderConfigApi({type: 'all'}).then((res) => {
        let level = [];
        let system = [];
        res.data.forEach((item, index) => {
          if (item.type === 2) {
            level.push({key: item.value, value: item.key});
          }else if(item.type === 4){
            system[item.key]= item.value;
          }
        });
        this.workOrderLevel = level;
        this.workOrderSystem = system;
      })
    },
    onTransferOrder(){
      let acceptor_id = this.form.acceptor_id?.id??'';
      let level_code = this.form.level_code;
      if(level_code){
        level_code = level_code.toString();
      }
      if(level_code === 0){
        level_code = '0';
      }
      this.TransferInfo = {id:this.form.id,acceptor_id:acceptor_id?acceptor_id.toString():'',level:level_code,classify:this.form.classify_code,state_code:this.form.state_code};
      this.dialogVisibleTransferOrder = true
    },
    onClaimOrder(){
      let acceptor_id = this.form.acceptor_id?.id??'';
      let level_code = this.form.level_code;
      if(level_code){
        level_code = level_code.toString();
      }
      if(level_code === 0){
        level_code = '0';
      }
      this.TransferInfo = {id:this.form.id,acceptor_id:acceptor_id?acceptor_id.toString():'',level:level_code,classify:this.form.classify_code,state_code:this.form.state_code};
      this.dialogVisibleClaimOrder = true
    },
    handlePreview(file) {
      window.open(file?.response?.url || '')
    },
    beforeRemove(file) {
      if(!this.isProjectDisabled){
        return this.$confirm(`确定移除 ${file.name}？`);
      }else{
        return  false;
      }
    },
    handleSuccess(response, file, fileList) {
      this.fileList = fileList;
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
    },
    beforeRemoveResult(file) {
      return false;
    },
    handleRemoveResult(file, fileList){
      return false;
    },
    beforeUpload(file){
      if (file.size / 1024 / 1024   > 5) {
        this.$notify({
          message:  "上传文件大小不能超过5M!",
          type: "error",
        });
        return false;
      }
    },
    getProjectList(systemId){
      getDevOpsSpaceFindProjectNameApi({isEffective:true,systemId: systemId}).then(res=>{
        if(res.data){
          this.projectList = res.data;
        }
      })
    },
    async getMeetList(id){
      await getDevOpsSpaceMeetListApi({demandId: id}).then((res)=>{
        this.meetList = res.data;
      });
    },
    async change(){
      await this.getMeetList(this.form.id);

    },
    async getHistoryList(){
      await getDevOpsSpaceHistoryTaskListApi({type:2,busiId: this.form.id}).then((res)=>{
        this.historylist = res.data;
      });
    },
    // 变更需求状态
    onChangePStatus(){
      this.$refs["pStatusForm"].validate(async (valid) => {
        if (valid) {
          this.queryChangePStatus()
        }
      })
    },
    onChangePUat(){
      this.$refs["pUatForm"].validate(async (valid) => {
        if (valid) {
          this.onSubmitDemand(4);
          //this.queryChangePStatus()
        }
      })
    },
    onChangePro(){
      this.$refs["proForm"].validate(async (valid) => {
        if (valid) {
          this.onSubmitDemand(7);
          //console.log(33333333)
          //this.queryChangePStatus()
        }
      })
    },
    async queryChangePStatus(isRestart = false){
      this.$set(this.loading, 'submitReset', true)
      if(this.pStatusForm.status == '13'){
        if(this.form.status < 6){
          this.$notify({
            message:  "开发阶段中/测试阶段中/UAT阶段中才允许暂停",
            type: "error",
          })
          return false;
        }
      }
      try {
        let params =  { ...this.pStatusForm, id:this.form.id, status:Number(this.pStatusForm.status), isRestart:isRestart}
        const ret = await postDevOpsSpaceUserPmEditStatusApi(params);
        if(ret.status === 'success'){
          this.dialogVisiblePStatus = false;
          this.$notify({
            message: ret.message || "变更成功",
            type: "success",
          })
          this.hideDialogVisible()
        }else{
          this.$notify({
            message: ret.message || "变更失败",
            type: "error",
          })
        }
        this.loading.submitReset = false;
      } catch (error) {
        this.$notify({
          message: error || "变更失败",
          type: "error",
        })
        this.loading.submitReset = false;
      }
    },
    showDialogVisibleOtherTask(type,row){
      this.taskInfo = row;
      this.dialogVisibleCreateWorkTask = true;
    },
    // 回退
    onRollback(){
      this.$confirm('此操作将回退到上一步, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
        type: 'warning'
      }).then(async () => {
        try {
          this.$set(this.loading, 'submitRollBack', true)
          const ret = await postDevOpsSpaceUserPmEditStatusApi({id:this.form.id,isRollBack: true})
          if (ret.status === 'success') {
            this.$notify({
              message: '回退成功',
              type: "success",
            })
            setTimeout(() => {
              this.handleClose()
            }, 500)
          } else {
            this.$notify({
              message: ret.message || "回退失败",
              type: "error",
            })
          }
        } catch (error) {
          this.$notify({
            message: error || "网络错误",
            type: "error",
          })
        } finally {
          this.loading.submitRollBack = false;
        }
      })
    },
    changeProjectSystem(val) {

      let arr = {};
      getDevOpsSpaceAllUserListApi({userType: 5,project_system_id:val}).then((res)=>{
        res.data.forEach((item,index)=>{
          arr[item.id] = item.user_name;
        });
        this.reviewerSelect = arr;
      });


      this.getProjectList(val);

    },
    changeStep(step) {
      this.step = step;
      this.changeProjectSystem(this.form.systemId);
    },
    getCellClass(row, column, rowIndex, columnIndex) {
      return "padding: 4px 0;height:20px;background:#7F7F7F;color:#fff;font-size:14px;"
    },
    // 表格样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if(columnIndex == 0 || columnIndex == 1){
        return "font-size: 12px;font-weight: bold;padding:6px 0;";
      }
      return "font-size: 12px;padding:6px 0;";
    },
    // 获取需求详情
    async init(id) {
      this.loading.dialog = true
      try {
        const ret = await getDevOpsSpaceWorkOrderDetailApi({work_id:id });
        const info = ret.data || {};
        this.username_cn = info.submitter_id.nameZh + '('+ info.submitter_id.nameEn +')';
        this.department = info.dept;
        this.create_date = info.create_time;
        this.fileList = info.adjunct?JSON.parse(info.adjunct):[];
        if(this.fileList.length > 0){
          if(this.fileList[0]  && ((this.fileList[0]['response'] && !this.fileList[0]['response']['url'])) || !this.fileList[0]['response']){
            this.fileList = [];
          }
        }

        let acceptor_id = info?.acceptor_id?.id??'';
       this.resultList = info.dispose_proof?JSON.parse(info.dispose_proof):[];
        this.form = {
          ...this.form,
          ...info,
          type:info.type_code?info.type_code.toString(): '0',
          accepted_user_id:info?.acceptor_id?.id??'0',
          accepted_user_nameZh:info?.acceptor_id?.nameZh??'',
          classify:info.classify_code?info.classify_code.toString():'',
          level: info.level_code?info.level_code.toString():'0',
          level_name:info.level,
          classify_name:info.classify,
          acceptor_id:acceptor_id.toString(),
          project_system_id:info.project_system_id ? info.project_system_id:'',
          project_system:info.project_system,
        };
        if(this.form.accepted_user_id) this.form.accepted_user_id = this.form.accepted_user_id.toString();
        if (this.hasImage()) this.edithHeight = '46vh';
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        })
      } finally {
        this.loading.dialog = false
      }
    },
    onApplyRelease(){
      this.dialogVisibleApplyRelease = true;
    },
    async onApplySkipRelease(){
      this.$refs["pSkipForm"].validate(async (valid) => {
        if (valid) {
          this.$confirm("此操作将跳过发布, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(async () => {
            try{
              this.$set(this.loading, 'skipRelease', true)
              const res = await getDevOpsSpaceDemandSkipApi({demandId:this.form.id,skipReason:this.pSkipForm.skipReason});
              if(res.status === 'success'){
                this.$notify({
                  message: '提交成功',
                  type: "success",
                })
                setTimeout(() => {
                  this.handleClose()

                }, 500)
                this.loading.skipRelease =false;
              }else{
                this.$notify({
                  message: res.message || "提交失败",
                  type: "error",
                })
                this.loading.skipRelease =false;
              }
            }catch (error) {
              this.$notify({
                message: error || "网络错误",
                type: "error",
              })
              this.loading.skipRelease =false;
            }finally {
              this.loading.skipRelease =false;
            }

          });
        }
      })
    },
    onAddSystem(){
      this.$refs["addSystemForm"].validate(async (valid) => {
        if (valid) {
          try {
            this.$set(this.loading, 'addSystemLoad', true);
            const ret =  await postDevOpsSpaceCreateSystemApi(this.addSystemForm);
            if (ret.status === 'success') {
              this.dialogVisibleAddSystem = false;
              await this.getWorkOrderConfig();
              this.$notify({
                message: ret.message || "成功",
                type: "success",
              })
            } else {
              this.$notify({
                message: ret.message || "失败",
                type: "error",
              })
            }
          } catch (error) {
            this.$notify({
              message: error || "网络错误",
              type: "error",
            })
          } finally {
            this.loading.addSystemLoad = false;
          }
        }

      })
    },
    onAddDemand(row = ''){
      if(!row){
        let orderCreator = this.form.creator_id?.id??'';
        this.demandInfo = {orderTitle:this.form.title,orderDesc:this.form.desc,orderCreator:orderCreator,orderType:this.form.type,project_system_id:this.form.project_system_id};
        //this.demandInfo = '';
      }
      if(row) this.demandInfo = row;
      this.dialogVisibleCreateDemand = true;
    },
    // 添加任务
    onAddTask(type, row) {
      const {status,techDesc,techDocLink,id,name,pmId,pm,prdLink} = this.form;
      if (type === 'add') {
        this.formTaskInfo = { status, techDesc,techDocLink: this.formatLink(techDocLink), id,name, pmId, pm, prdLink: this.formatLink(prdLink),taskInfo: { pid: id, name } }
      }
      if (type === 'copy') {
        this.formTaskInfo = { status, techDesc,techDocLink: this.formatLink(techDocLink), id,name, pmId, pm, prdLink: this.formatLink(prdLink),taskInfo: { pid: id, name } }
        this.formTaskInfo.openType = 'copy';
        this.formTaskInfo.taskId = row.taskId;
      }
      this.dialogVisibleTask = true;
    },
    // 添加任务
    onAddWorkTask(row) {
      if(row){
        this.taskInfo = row;
      }else{
        let orderCreator = this.form.creator_id?.id??'';
        this.taskInfo = {orderTitle:this.form.title,orderDesc:this.form.desc,orderCreator:orderCreator};
      }
      this.dialogVisibleCreateWorkTask = true;
    },
    // 添加会议记录
    onAddMeet(type, row) {
      this.dialogVisibleMeet = true;
    },
    // 链接判断
    formatLink(val){
      if(!val) return '';
      return val.startsWith('http') ? val :`http://${val}`
    },
    // 提交
    async onSubmit(close = true) {
      if(this.form.type != 1 && this.form.acceptor_id && !this.isUpdata){
        this.form.acceptor_id = '';
        this.form.project_system_id = '';
      }
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.moduleSubmit(close)
        }
      });
    },
    //确认评审
    async onSubmitConfirmReviewer(){
      if(this.tasks.length < 1){
        this.$notify({
          message: "请添加开发任务和测试任务!",
          type: "error",
        })
        return false;
      }
      const {
        name = "",
        projectId = "",
        systemId = '',
        demanderId = '',
        pmId = [],
        priority = "",
        planFinishDate = "",
        demandDesc = "",
        reviewerId = '',
        prdLink = '',
        expectFinishDate = '',
        techDocLink = '',
        techDesc = '',
        p_status = '',
        id = '',
        tag = '',
      } = this.form;
      const param = { name, demandDesc,projectId, id: id, demanderId:Number(demanderId) ,pmId: Number(pmId), systemId:Number(systemId), project_status: p_status, priority, reviewerId:Number(reviewerId),planFinishDate, expectFinishDate, prdLink: this.formatLink(prdLink), techDocLink: this.formatLink(techDocLink),techDesc:techDesc,tag};
      this.$set(this.loading, 'submitConfirmReviewer', true);
      await postDevOpsSpaceEditDemandApi({...param, demand_id: this.form.id || "" }).then((ret)=>{
        if(ret.status === 'success'){
          this.$set(this.loading, 'submitConfirmReviewer', false);
          this.onSubmitDemand(3)
        }else{
          this.$notify({
            message: ret.message || "提交失败",
            type: "error",
          })
          this.$set(this.loading, 'submitConfirmReviewer', false);
        }
      })
    },
    //提交需求评审
    async onSubmitDemand(type){
      /* if(this.form.reviewerId){
         this.form.reviewerId = this.form.reviewerId.toString();
       }*//*
      this.rules.reviewerId = true;
      this.rules.prdLink = true;*/
      if(type === 1 || type === 2){
        if(!this.form.reviewerId){
          this.$notify({
            message: "技术负责人必填",
            type: "error",
          })
          return false;
        }
        if(!this.form.prdLink){
          this.$notify({
            message: "PRD必填",
            type: "error",
          })
          return false;
        }
      }
      let content = '此操作将进行到下一步, 是否继续?';
      if(type === 1){
        content = '请确认提交需求评审？';
      }
      if(type === 2){
        content = '请确认提交技术评审？';
      }
      if(!this.form.demandDesc){
        this.form.demandDesc = '1';
      }

      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.$confirm(content, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            center: true,
            type: 'warning'
          }).then(async () => {
            this.form.reviewerId = this.form.reviewerId.toString();
            try {
              if(type === 2)  this.$set(this.loading, 'submitReviewed', true);
              if(type === 1)  this.$set(this.loading, 'submitDemand', true);
              if(type === 6)  this.$set(this.loading, 'submitCancel', true);
              if(type === 7)  this.$set(this.loading, 'submitComplete', true);
              if(type === 4)  this.$set(this.loading, 'submitUat', true);
              if(type === 3)  this.$set(this.loading, 'submitConfirmReviewer', true);


              let params =  {id: this.form.id,type:type};
              if(type === 2){
                await this.onSubmit();
              }
              if(type === 4){
                params = {...params,...this.pUatForm,}
              }
              if(type === 7){
                params = {...params,...this.proForm,}
              }
              await postDevOpsSpaceSubmitDemandApi(params).then((result)=>{
                if(result.status === 'success'){
                  this.$notify({
                    message: result.message || '提交成功',
                    type: "success",
                  })
                  setTimeout(() => {
                    this.handleClose()
                  }, 500)
                }else{
                  this.$notify({
                    message: result.message || "提交失败",
                    type: "error",
                  })
                  this.handleClose()
                }

                this.loading.submitReviewed = false;
                this.loading.submitDemand = false;
                this.loading.submitCancel = false;
                this.loading.submitComplete = false;
                this.loading.submitUat = false;
                this.loading.submitConfirmReviewer = false;
              });
            } catch (error) {
              this.$notify({
                message: error || "网络错误",
                type: "error",
              })
            } finally {
              this.loading.submitReviewed = false;
              this.loading.submitDemand = false;
              this.loading.submitCancel = false;
              this.loading.submitComplete = false;
              this.loading.submitUat = false;
              this.loading.submitConfirmReviewer = false;
            }
          })
        }
      })
    },
    // 调用提交接口
    async moduleSubmit(close = true){
      try {
        close && this.$set(this.loading, 'submit', true)
       if (this.fileList.length > 0) {
          this.form.adjunct = JSON.stringify(this.fileList);
        }
        // id 存在 更新 不存在 创建
        const ret = this.isUpdata ? await postDevOpsSpaceUpdateWorkOrderApi({...this.form,work_id:this.form.id}) : await postDevOpsSpaceCreateWorkOrderApi({...this.form,type:Number(this.form.type)});
        if (ret.status === 'success') {
          if (close) {
            this.$notify({
              message: '提交成功',
              type: "success",
            })
            setTimeout(() => {
              this.handleClose()

            }, 500)
          }
        } else {
          this.$notify({
            message: ret.message || "失败",
            type: "error",
          })
        }
      } catch (error) {
        this.$notify({
          message: error || "网络错误",
          type: "error",
        })
      } finally {
        this.loading.submit = false;
      }
    },
    changTechDocLink(val){
      this.saveSubmit();
    },
    changTechDesc(){
      this.saveSubmit();
    },
    async saveSubmit(){
      const {
        name = "",
        projectId = "",
        systemId = '',
        demanderId = '',
        pmId = [],
        priority = "",
        planFinishDate = "",
        demandDesc = "",
        reviewerId = '',
        prdLink = '',
        expectFinishDate = '',
        techDocLink = '',
        techDesc = '',
        p_status = '',
        id = '',
      } = this.form;
      const param = { name, demandDesc,projectId, id: id, demanderId:Number(demanderId) ,pmId: Number(pmId), systemId:Number(systemId), project_status: p_status, priority, reviewerId:Number(reviewerId),planFinishDate, expectFinishDate, prdLink: this.formatLink(prdLink), techDocLink: this.formatLink(techDocLink),techDesc:techDesc};
      await postDevOpsSpaceEditDemandApi({...param, demand_id: this.form.id || "" });
    },
    // 修复 input 框输入 乱聚焦到富文本的问题
    focusLinkFn(refName) {
      setTimeout(() => {
        this.$refs[refName].focus()
      })
    },
    // 跳转外链
    linkFn(url) {
      window.open(url)
    },
    hasImage() {
      if(this.form.desc){
        return /<img[^>]+>/i.test(this.form.desc);
      }
     return false;
    },
    // 打开新的模块
    linkToModel(row, type, back = '') {
      let newRow = {
        ...this.form,
        ...row,
      }
      /*if(type === 'task'){
        newRow.pid = this.form.id;
        newRow.id = row.taskId;
      }*/
      this.showDialogVisible(type, newRow, back)
    },
    // 关闭弹窗
    handleClose(step) {
      this.hideDialogVisible(step)
    },
    // 修改富文本内容
    changeContent(val) {
      this.form.desc = val;
    },
    // 修改富文本内容
    changeUatContent(val) {
      this.pUatForm.uatDetail = val;
    },
    changeProContent(val) {
      this.proForm.proDetail = val;
    },
    // 修改富文本内容
    changeSkipContent(val) {
      this.pSkipForm.skipReason = val;
    },
    changeUpdateDateReasonContent(val){
      this.updateTimeForm.update_date_reason = val;
    },
    // 删除任务
    onDeleteTask(row) {
      this.$confirm("此操作将删除该任务, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.$set(this.loading, 'task' + row.taskId, true)
        try {
          const res = await postDevOpsSpaceDeleteTaskApi({
            id: row.taskId,
          });
          if (res.status === "success") {
            this.queryTaskList(this.form.id)
          } else {
            this.$notify({
              message: res?.data?.msg || "删除失败",
              type: "error",
            })
          }
        } catch (error) {
          this.$notify({
            message: error || "数据错误",
            type: "error",
          })
        } finally {
          this.loading['task' + row.taskId] = false;
        }
      });
    },
    // 删除测试任务
    onDeleteTestTask(row) {
      this.$confirm("此操作将删除该测试任务, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.$set(this.loading, 'test' + row.id, true)
        try {
          const res = await postDevOpsSpaceDeleteTestTaskApi({
            id: row.id,
          });
          if (res.status === "success") {
            this.queryTestTaskList(this.form.id)
          } else {
            this.$notify({
              message: res.message || "删除失败",
              type: "error",
            })
          }
        } catch (error) {
          this.$notify({
            message: error || "数据错误",
            type: "error",
          })
        } finally {
          this.loading['test' + row.id] = false;
        }
      });
    },
    handleApplyReleaseClose(){
      this.dialogVisibleApplyRelease = false;
      this.init(this.form.id);
      this.queryTaskList(this.form.id)
      this.queryTestTaskList(this.form.id)
    },
    // 批量导入
    createImportTask(type, row) {
      this.dialogVisibleImportTask = true;
    },
    // 关闭任务弹窗
    handleTaskClose(info = '') {
      this.dialogVisibleTask = false;
      this.init(this.form.id);
      this.queryTaskList(this.form.id)
      this.queryTestTaskList(this.form.id)
      this.getHistoryList();
      this.getMeetList(this.form.id);
    },
    handleTestTaskClose(){
      this.dialogVisibleTestTask = false;
      this.init(this.form.id);
      this.queryTaskList(this.form.id)
      this.queryTestTaskList(this.form.id)
      this.getHistoryList();
      this.getMeetList(this.form.id);
    },
    handleImportTaskClose(){
      this.dialogVisibleImportTask = false;
      this.init(this.form.id);
      this.queryTaskList(this.form.id)
      this.queryTestTaskList(this.form.id)
      this.getHistoryList();
      this.getMeetList(this.form.id);
    },
    handleTransferOrderClose(){
      this.init(this.form.id);
      this.workOrderDemandList();
      this.workOrderTaskList();
      this.getReminderWorkOrderListlApi();
      this.hideDialogVisible();
      this.dialogVisibleTransferOrder = false;
    },
    handleClaimOrderClose(){
      this.init(this.form.id);
      this.workOrderDemandList();
      this.workOrderTaskList();
      this.getReminderWorkOrderListlApi();
      this.hideDialogVisible();
      this.dialogVisibleClaimOrder = false;
    },
    handleCreateDemandClose(){
      this.init(this.form.id);
      this.workOrderDemandList();
      this.workOrderTaskList();
      this.getReminderWorkOrderListlApi();
      this.dialogVisibleCreateDemand = false;
    },
    handleCreateWorkTaskClose(){
      this.init(this.form.id);
      this.workOrderDemandList();
      this.workOrderTaskList();
      this.getReminderWorkOrderListlApi();
      this.dialogVisibleCreateWorkTask = false;
    },
    handleFinishWorkOrderClose(){
      this.init(this.form.id);
      this.workOrderDemandList();
      this.workOrderTaskList();
      this.getReminderWorkOrderListlApi();
      this.dialogVisibleFinishWorkOrder = false;
    },
    handleFinishValidateWorkOrderClose(){
      this.init(this.form.id);
      this.workOrderDemandList();
      this.workOrderTaskList();
      this.getReminderWorkOrderListlApi();
      this.dialogVisibleValidateWorkOrder = false;
    },
    // 关闭任务弹窗
    handleMeetClose() {
      this.dialogVisibleMeet = false;
      this.getMeetList(this.form.id);
      this.init(this.form.id)
      this.queryTaskList(this.form.id)
      this.queryTestTaskList(this.form.id)
      this.getHistoryList();
    },
    // 任务列表
    async queryTaskList(id) {
      try {
        const res = await getDevOpsSpaceProducerListApi({ demandId: id });
        this.tasks = res.data || []
      } catch (error) {
        console.error(error)
      }
    },
    // 获取测试任务列表
    async queryTestTaskList(id) {
      try {
        const res = await getDevOpsSpaceDemandTestTaskApi({ demandId: id });
        this.testTasks = res.data || []
      } catch (error) {
        console.error(error)
      }
    },
    onChangeTakeUser(){
        if (this.pUserForm.submitter_id) {
          if(this.allUserList.ALLUSERTYPE1 && this.allUserList.ALLUSERTYPE1[this.pUserForm.submitter_id]){
            this.username_cn = this.allUserList.ALLUSERTYPE1[this.pUserForm.submitter_id];
            this.form.submitter_id = this.pUserForm.submitter_id;
          }
        }else{
          const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
          const username_cn = this.$store.state.devOps.userInfo.user_name_zh? this.$store.state.devOps.userInfo.user_name_zh : '';
          const username_id = this.$store.state.devOps.userInfo.userId? this.$store.state.devOps.userInfo.userId : '';
          this.username_cn = username_cn + '(' +username+')';
          this.form.submitter_id = username_id;
        }
      this.getWorkOrderUserDepartment(this.pUserForm.submitter_id);
      this.dialogVisibleTakeUser = false;

    },
    //完结工单
    onFinishWorkOrder(){
      this.dialogVisibleFinishWorkOrder = true;
    },
    //验收工单
    onFinishValidateWorkOrder(){
      this.dialogVisibleValidateWorkOrder = true;
    },
    //取消工单
    onCancelWorkOrder(row) {
      this.$confirm("此操作将取消该工单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.$set(this.loading, 'cancelWorkOrder', true)
        try {
          const res = await postDevOpsSpaceClaimWorkOrderApi({
            workId: this.form.id,
            type:'4',
          });
          if (res.status === "success") {
            this.$notify({
              message: res.message || '提交成功',
              type: "success",
            })
            setTimeout(() => {
              this.handleClose()
            }, 500)
          } else {
            this.$notify({
              message: res?.data?.msg || "删除失败",
              type: "error",
            })
          }
        } catch (error) {
          this.$notify({
            message: error || "数据错误",
            type: "error",
          })
        } finally {
          this.loading['cancelWorkOrder'] = false;
        }
      });
    },
    getNowDate(){
      var today = new Date();
      var year = today.getFullYear();//获取年份
      var month = today.getMonth() + 1;//获取月份
      var day = today.getDate();//获取日期
      let cmonth = month < 10 ? '0'+month : month;
      let cday = day < 10 ? '0' + day : day;
      let h = today.getHours() < 10 ? '0'+today.getHours() : today.getHours();
      let m = today.getMinutes() < 10 ? '0'+today.getMinutes() : today.getMinutes();
      let s = today.getSeconds() < 10 ? '0'+today.getSeconds() : today.getSeconds();
      return year + "-" + cmonth + "-" + cday + " " + h + ":" + m + ":" + s;
    },
    getDate(){
      var today = new Date();
      var year = today.getFullYear();//获取年份
      var month = today.getMonth() + 1;//获取月份
      var day = today.getDate();//获取日期
      let cmonth = month < 10 ? '0'+month : month;
      let cday = day < 10 ? '0' + day : day;
      return year + "-" + cmonth + "-" + cday;
    },
    // 将多个英文名转换为中文
    formatEnToUtf8,
  }
};
</script>
<style lang="scss">
.demand_model_dialog {
  .comment_warp {
    .comment_item>div {
      display: flex;
      margin: 0;
      margin-bottom: 12px;

      .el-textarea__inner {
        font-weight: bold;
      }
    }
  }

  .table_text_click {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .table_text_click_new {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
  .table_text_no_click {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .el-dialog__body {
    padding-bottom: 0;
  }
}

.popperDom {
  max-width: 240px;
}
.meet-line{
  height: 1px;
  border-top: 1px solid #ddd;
  text-align: center;
  margin-top: 20px;
}
.meet-line label{
  position: relative;
  top: -8px;
  background: #fff;
  padding: 0 20px;
  font-weight: bold;
  color: #606266;
}
.prdLink label:before {
  content: '*';
  color: #F56C6C;
  margin-right: 4px;
}
.followList{
  max-height: 20vh;
  overflow-y: auto;
  white-space: pre-wrap;
  /* background: #f1fbec; */
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
  line-height: 24px;
  padding: 10px;
}
.upload-result .el-upload-list__item-delete {
  display: none !important; /* 隐藏删除按钮 */
}
.upload-result .el-upload-list__item-status-label {
  display: none !important; /* 隐藏删除按钮 */
}

</style>
